export const smartFormId = 'cchlDwQOn0jASRlDEzm8';
export const savvyScriptUrl = 'https://cdn.heysavvy.com/wc/savvy.min.js';

export const onboardingFlowId = 'UkI2pO4KD0xXQLHkN1GG';
export const loggedOutHomepageFlowId = '8UC9Wo157ptNV5U4MJ1Q';
export const educatorsPageFlowId = 'E9OjYp3VBqYRkTzIL45A';
export const marketingRuxFlowId = 'WHwrb9pMzk1hM2RRGcsR';
export const organicRuxFlowId = 'O8KurWp6lOLektTC9HzR';
